if (!customElements.get('steps-slider')) {
  class StepsSlider extends HTMLElement {
    selectors = {
      slider: '.swiper',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        slider: this.querySelector(this.selectors.slider),
      };

      this.settings = {
        slidesPerView: 1.7,
        spaceBetween: 20,
        navigation: {
          prevEl: this.querySelector('.slider__arrow.arrow-left'),
          nextEl: this.querySelector('.slider__arrow.arrow-right'),
        },
        breakpoints: {
          750: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      };

      this.slider = new Swiper(this.elements.slider, this.settings);

      if (Shopify.designMode) {
        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

      if (!Number.isNaN(targetIndex)) {
        this.slider.slideTo(targetIndex);
      }
    }
  }
  customElements.define('steps-slider', StepsSlider);
}
